export default class Healthcheck {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }

  healthcheck() {
    return this.client.get(`/health`);
  }
}
